<div class="toast-container">
    <div *ngFor="let toast of activeToasts" 
         class="toast" 
         [@toastAnimation]="toast.state"
         [ngClass]="toast.type">
        <i *ngIf="toast.icon" [class]="toast.icon"></i>
        <span>{{toast.message}}</span>
    </div>
</div>